import React, {ReactNode} from 'react';
import * as XLSX from 'xlsx'
import Checkbox from '../custom-components/checkbox/Checkbox';
import DropdownMenu from '../custom-components/dropdown/DropdownMenu';
import Modal from '../custom-components/modal/modal';
import history from '../../../history';
import userAdminService from '../../../services/user-admin.service';
import './user-admin-list.component.scss'


import temp_password_icon from './../../../../assets/img/element_picto_interface_user_mdp_temporaire.png'
import valid_password_icon from './../../../../assets/img/element_picto_interface_user_mdp_valide.png'
import delete_cross from './../../../../assets/img/element_croix_rouge_supprim.png'
import modify_icon from './../../../../assets/img/element_modification_grey_v2.png'
import {AccountUser, Resource, UserModule} from '../../../data/models/AccountUser/user.model';
import {RoleDetail, RoleLevel, UserStatus} from '../../enum/UserEnum';
import {FileDrop} from '../custom-components/fileUploader/fileUploader';
import UserAdminService from "../../../services/user-admin.service";
import NotificationSnackbar from "../custom-components/notificationSnackbar/NotificationSnackbar";
import {summarizeResetResponse} from "../../../services/reset-result";


const PasswordFilter = {
    ALL: 1,
    DEFINED: 2,
    UNDEFINED: 3
}

const RoleFilter = {
    ALL: 1,
    GLOBAL: 2,
    LOCAL: 3
}

const actionActiveMenuList: string[] = [
    'Désactiver un utilisateur',
    'Réinitialiser le mot de passe',
    'Réinitialiser le mot de passe (faux email)',
    'Supprimer un utilisateur'
];
const actionInactiveMenuList: string[] = [
    'Activer un utilisateur',
    'Réinitialiser le mot de passe',
    'Réinitialiser le mot de passe (faux email)',
    'Supprimer un utilisateur'
];

const importUsersOptionList: string[] = [
    'SSO',
    'Standard'
]

export interface Props {
    list: any[];
    key: string;
    isUsersActive: boolean;
    updateData: () => void;
    client: string;
    children?: ReactNode;
}

interface State {
    currentList: any[],
    selectedUsers: AccountUser[],
    passwordFilter: number,
    roleFilter: number,
    selectAll: boolean,
    showModal: boolean;
    disableActionValidation: boolean;
    disableActions: boolean;
    isExporting: boolean;
    modalAction?: () => void;
    modalEnabledAction: string;
    modalTitle: string;
    modalContent: any;
    idxPasswordFilter: number;
    idxRoleFilter: number;
    inputFilter: string;
    usersToImport: AccountUser[];
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: 'success' | 'error';
    snackbarAutoHideDuration: number;
}

class UserAdminListFragment extends React.Component<Props, State> {
    dropdownRef: React.RefObject<DropdownMenu>;

    constructor(props: Props) {
        super(props);
        this.state = {
            isExporting: false,
            currentList: this.props.list,
            selectedUsers: [],
            passwordFilter: PasswordFilter.ALL,
            roleFilter: RoleFilter.ALL,
            selectAll: false,
            showModal: false,
            disableActionValidation: false,
            disableActions: true,
            modalEnabledAction: '',
            modalTitle: '',
            modalContent: '',
            idxPasswordFilter: 0,
            idxRoleFilter: 0,
            inputFilter: '',
            usersToImport: [],
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'error',
            snackbarAutoHideDuration: 30000
        };
        this.dropdownRef = React.createRef();
        this.handleDropdowns = this.handleDropdowns.bind(this);
        this.clientHasChanged = this.clientHasChanged.bind(this);
        this.handleSearchFilter = this.handleSearchFilter.bind(this);
        this.handlePasswordFilter = this.handlePasswordFilter.bind(this);
        this.updateInfos = this.updateInfos.bind(this);
        this.select = this.select.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.resetPasswordFakeEmail = this.resetPasswordFakeEmail.bind(this);
        this.activateUsers = this.activateUsers.bind(this);
        this.deactivateUsers = this.deactivateUsers.bind(this);
        this.deleteUsers = this.deleteUsers.bind(this);
        this.getSelection = this.getSelection.bind(this);
        this.readExcelFile = this.readExcelFile.bind(this);
        this.convertToAccountUsers = this.convertToAccountUsers.bind(this);
        this.importUsersFromExcel = this.importUsersFromExcel.bind(this);
    }

    public clientHasChanged(): void {
        this.setState({currentList: this.props.list});
    }

    public handleSearchFilter = (input: any) => {
        let inputValue = input.target.value.toLowerCase();
        this.setState({
            inputFilter: inputValue,
            currentList: this.props.list.filter(user => user && user.user && (
                user.user.firstName.toLowerCase().includes(inputValue) ||
                user.user.lastName.toLowerCase().includes(inputValue) ||
                user.user.mail.toLowerCase().includes(inputValue)
            ))
        })
    }

    public handlePasswordFilter = (event: any) => {
        if (event.target.options) {
            let index = event.target.options.selectedIndex;
            this.setState({passwordFilter: index}, this.updateInfos);
        }
    }

    public updateInfos(): void {
        if (this.state.passwordFilter === PasswordFilter.DEFINED && this.state.roleFilter === RoleFilter.ALL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status !== UserStatus.FORCE_CHANGE_PASSWORD)});
        } else if (this.state.passwordFilter === PasswordFilter.UNDEFINED && this.state.roleFilter === RoleFilter.ALL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status === UserStatus.FORCE_CHANGE_PASSWORD)});
        } else if (this.state.passwordFilter === PasswordFilter.ALL && this.state.roleFilter === RoleFilter.GLOBAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.role.scope === 'global')});
        } else if (this.state.passwordFilter === PasswordFilter.ALL && this.state.roleFilter === RoleFilter.LOCAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.role.scope === 'local')});
        } else if (this.state.passwordFilter === PasswordFilter.DEFINED && this.state.roleFilter === RoleFilter.GLOBAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status !== UserStatus.FORCE_CHANGE_PASSWORD && user.user.role.scope === 'global')});
        } else if (this.state.passwordFilter === PasswordFilter.DEFINED && this.state.roleFilter === RoleFilter.LOCAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status !== UserStatus.FORCE_CHANGE_PASSWORD && user.user.role.scope === 'local')});
        } else if (this.state.passwordFilter === PasswordFilter.UNDEFINED && this.state.roleFilter === RoleFilter.GLOBAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status === UserStatus.FORCE_CHANGE_PASSWORD && user.user.role.scope === 'global')});
        } else if (this.state.passwordFilter === PasswordFilter.UNDEFINED && this.state.roleFilter === RoleFilter.LOCAL) {
            this.setState({currentList: this.props.list.filter(user => user.user.status === UserStatus.FORCE_CHANGE_PASSWORD && user.user.role.scope === 'local')});
        } else {
            this.setState({currentList: this.props.list});
        }
        this.setState({inputFilter: ''});
    }

    public selectAll(selectAll: boolean): void {
        this.setState({
            selectAll: !selectAll,
            currentList: this.state.currentList.map((user: any) => {
                user.select = !this.state.selectAll;
                return user;
            })
        }, this.getSelection);
    }

    public select(id: string): void {
        this.setState({
            currentList: this.state.currentList.map((user: any) => {
                if (user.user.id === id) {
                    user.select = !user.select;
                }
                return user;
            }),
            selectAll: this.state.selectedUsers.length === this.state.currentList.length ? true : this.state.selectAll
        }, this.getSelection);
    }

    public getSelection(): void {
        this.setState({selectedUsers: []})
        this.state.currentList.map((usr: any) => {
            if (usr.select === true) {
                this.state.selectedUsers.push(usr.user);
            }
        });
        this.setState(
            {disableActions: this.state.selectedUsers.length === 0 ? true : false}
        );
    
    }

    public handleDropdowns(actionName?: string): void {
        switch (actionName) {
            case 'Désactiver un utilisateur': {
                this.setState({
                    ...this.state,
                    modalEnabledAction: actionName,
                    modalTitle: 'Êtes-vous certains de vouloir désactiver cet utilisateur ?',
                    modalAction: this.deactivateUsers
                });
                break;
            }
            case 'Activer un utilisateur': {
                this.setState({
                    ...this.state,
                    modalEnabledAction: actionName,
                    modalTitle: 'Êtes-vous certains de vouloir activer cet utilisateur ?',
                    modalAction: this.activateUsers
                });
                break;
            }
            case 'Réinitialiser le mot de passe': {
                this.setState({
                    ...this.state,
                    modalEnabledAction: actionName,
                    modalTitle: 'Êtes-vous certains de vouloir réinitialiser le mot de passe de cet utilisateur ? Il recevra un nouveau mot de passe provisoire par email.',
                    modalAction: this.resetPassword
                });
                break;
            }
            case 'Réinitialiser le mot de passe (faux email)': {
                this.setState({
                    ...this.state,
                    modalEnabledAction: actionName,
                    modalTitle: "Êtes-vous certains de vouloir réinitialiser le mot de passe de cet utilisateur ? Le nouveau mot de passe sera envoyé au support, pas à l'utilisateur.",
                    modalAction: this.resetPasswordFakeEmail
                });
                break;
            }
            case 'Supprimer un utilisateur': {
                this.setState({
                    modalEnabledAction: actionName,
                    modalTitle: 'Êtes-vous certains de vouloir supprimer cet utilisateur ?',
                    modalAction: this.deleteUsers
                });
                break;
            }
            case 'SSO': {
                this.setState({
                    modalEnabledAction: actionName,
                    modalTitle: "Importer des utilisateurs SSO",
                    modalContent: <FileDrop readFile={(file: any) => this.readExcelFile(file, true)}></FileDrop>,
                    modalAction: this.importUsersFromExcel
                });
                break;
            }
            case 'Standard': {
                this.setState({
                    modalEnabledAction: actionName,
                    modalTitle: "Importer des utilisateurs standards",
                    modalContent: <FileDrop readFile={(file: any) => this.readExcelFile(file, false)}></FileDrop>,
                    modalAction: this.importUsersFromExcel
                });
                break;
            }
            default: {
                break;
            }
        }
        this.setState({showModal: !this.state.showModal});
    }

    public resetPassword(): void {
        this.resetSelectedPasswords(false);
    }

    public resetPasswordFakeEmail(): void {
        this.resetSelectedPasswords(true);
    }

    private resetSelectedPasswords(fakeEmail: boolean): void {
        this.getSelection();
        const users = this.state.selectedUsers;
        const mailById: { [id: string]: string } = {};
        users.forEach((user) => mailById[user.id] = user.mail);
        userAdminService.resetPasswords(users.map((user) => user.id), fakeEmail)
            .then((response) => {
                // Le microservice répond 200 même quand un utilisateur est refusé (SSO, échec
                // Cognito) : le résultat est dans le corps, pas dans le statut.
                window.alert(summarizeResetResponse(response.data, fakeEmail, mailById).message);
            })
            .catch((error) => {
                window.alert("Erreur lors de la réinitialisation des mots de passe, avec le message :" + error);
            })
            .then(() => this.props.updateData());
    }

    public deactivateUsers(): void {
        this.getSelection();
        userAdminService.deactivateUser(this.state.selectedUsers.map((user) => {
            return user.id;
        }));
        this.props.updateData();
    }

    public exportUsers(): void {
        this.setState(
            {isExporting:  true}
        );
        userAdminService.exportUsers(this.props.client)
            .then((response) => {
                try {
                    const csvData = response.data;
                    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                    const filename = `users_export_${new Date().toISOString().split('T')[0]}.csv`;
                    
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    
                    link.href = url;
                    link.setAttribute('download', filename);
                    link.style.display = 'none';
                    
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    window.URL.revokeObjectURL(url);
    
                    this.setState({
                        snackbarOpen: true,
                        snackbarMessage: 'Exportation des utilisateurs terminée',
                        snackbarSeverity: 'success'
                    });
                } catch (error) {
                    this.setState({
                    isExporting: false,
                        snackbarOpen: true,
                        snackbarMessage: 'Erreur lors de la préparation de l\'exportation',
                        snackbarSeverity: 'error'
                    });
                    
                }
            })
            .catch((error) => {
                this.setState({
                    snackbarOpen: true,
                    snackbarMessage: 'Erreur lors de l\'exportation des utilisateurs',
                    snackbarSeverity: 'error'
                });
                
                console.error('Export users service error:', error);
            }).finally(() => {
                this.setState({ isExporting: false });
            });
    }
    public activateUsers(): void {
        this.getSelection();
        userAdminService.activateUser(this.state.selectedUsers.map((user) => {
            return user.id;
        }));
        this.props.updateData();
    }

    public deleteUsers(): void {
        this.getSelection();
        userAdminService.deleteUser(this.props.client, this.state.selectedUsers.map((user) => {
            return user.id;
        }));
        this.props.updateData();
    }

    // Single reader for both standard and SSO imports; isSso flags the users (username = nameid,
    // no temp password/email — creation + SSO linking are handled downstream).
    async readExcelFile(file: any, isSso: boolean = false) {
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            this.setState({disableActionValidation: true})
            const data = new Uint8Array(e?.target.result);
            const workbook = XLSX.read(data, {type: 'array'});
            const accountWorksheet = workbook.Sheets[workbook.SheetNames[0]];
            const permissionWorksheet = workbook.Sheets[workbook.SheetNames[1]];
            const accountData = XLSX.utils.sheet_to_json(accountWorksheet, {raw: false});
            const permissionData = XLSX.utils.sheet_to_json(permissionWorksheet, {raw: false});
            const parsedUsers = await this.convertToAccountUsers(accountData, permissionData, isSso);
            this.setState({usersToImport: parsedUsers, disableActionValidation: false});
        };
        reader.readAsArrayBuffer(file);
    }

    validateResource(resourceName: string, resources: string[]): boolean {
        if (!resourceName.includes(':')) {
            return false;
        }

        const resourceType = resourceName.split(':')[1].trim();
        if (!resources.includes(resourceType)) {
            this.setState({
                showModal: false,
                snackbarOpen: true,
                snackbarMessage: "'" + resourceName + "' n'est pas valide.\n les sous roles acceptés sont:\n" + resources.join(",\n")
            })
        }

        return true;
    }

    async convertToAccountUsers(accountData: any[], permissionData: any[], isSso: boolean = false): Promise<AccountUser[]> {
        const userModulesResponse = await UserAdminService.getUserModules();
        const userModulesList = new Set<string>(userModulesResponse.data.map((um: UserModule) => um.name.toLowerCase()));
        const userModulesResourcesList = new Set<string>(userModulesResponse.data.flatMap((um: UserModule) => um.resources.map((r: Resource) => r.name)));

        return accountData.map((account: any) => {
            const isAdmin = (account.global_roles ?? '').trim() === RoleDetail.ADMIN.toLowerCase();
            // Trim every field: source spreadsheets often carry stray spaces (e.g. " poi "),
            // which would otherwise fail the exact matches below (userModulesList.has, level checks).
            const accountPermissions = permissionData
                .filter((permission: any) => (permission.email ?? '').trim() === (account.email ?? '').trim())
                .map((permission: any) => ({
                    ...permission,
                    role: (permission.role ?? '').trim(),
                    entity_code: (permission.entity_code ?? '').trim(),
                    level: (permission.level ?? '').trim(),
                    action: (permission.action ?? '').trim(),
                }));

            const roleTargets = accountPermissions
                .filter(permission => userModulesList.has(permission.role.toLowerCase()))
                .map(permission => permission.role.toLowerCase());
            if (isAdmin && !roleTargets.includes(RoleDetail.ADMIN.toLowerCase())) {
                roleTargets.push(RoleDetail.ADMIN.toLowerCase());
            }

            const untrimmedRoleSubtargets = accountPermissions
                .filter(permission => this.validateResource(permission.role, Array.from(userModulesResourcesList)))
                .map(permission => permission.role);
            const roleSubtargets = Array.from(
              new Set(
                untrimmedRoleSubtargets.map(r => r.split(':')[1].trim())
              )
            );
            // if the target(userModule) of a subtarget(userModuleResource) is not included, we add it
            const targetsFromSubTargets = untrimmedRoleSubtargets.map(r => r.split(':')[0].trim());
            targetsFromSubTargets.map(userModule => {
                if (!roleTargets.includes(userModule)) {
                    roleTargets.push(userModule);
                }
            })

            // Attribute all module resource if none of them is listed but the module is listed
            roleTargets.map(userModule => {
                if (!untrimmedRoleSubtargets.some(r => r.startsWith(userModule))) {
                    const moduleResources = userModulesResponse.data
                        .find((um: UserModule) => um.name == userModule)
                        .resources.map((r: Resource) => roleSubtargets.push(r.name))
                }
            })

            // Attribute all module resource if none of them is listed and the module is not listed and the user is admin
            const modulesUnderAdmin = ["poi", "campaign", "gmb", "gmb_post"];
            modulesUnderAdmin.map((userModule: string) => {
                if (isAdmin && !roleTargets.includes(userModule) && !untrimmedRoleSubtargets.some(r => r.startsWith(userModule))) {
                    const moduleResources = userModulesResponse.data
                        .find((um: UserModule) => um.name == userModule)
                        .resources.map((r: Resource) => roleSubtargets.push(r.name))
                }
            })

            // Dedup: there is one permission row per module, each repeating the same entity_code.
            const isGroupLevel = (permission: any) => (permission.level || '').toLowerCase() === RoleLevel.GROUP.toLowerCase();
            const groupCodes = Array.from(new Set(
                accountPermissions.filter(isGroupLevel).map(permission => permission.entity_code).filter(Boolean)
            ));
            const storeCodes = Array.from(new Set(
                accountPermissions.filter(permission => !isGroupLevel(permission)).map(permission => permission.entity_code).filter(Boolean)
            ));

            let scope: string;
            if (isAdmin) {
                scope = RoleLevel.GLOBAL.toLowerCase();
            } else if (groupCodes.length > 0 && storeCodes.length === 0) {
                scope = RoleLevel.GROUP.toLowerCase();
            } else {
                scope = RoleLevel.LOCAL.toLowerCase();
            }

            return {
                id: '',
                firstName: (account.firstname ?? '').trim(),
                lastName: (account.lastname ?? '').trim(),
                username: (account.nameid ?? '').trim() || (account.email ?? '').trim(),
                nameid: (account.nameid ?? '').trim(),
                mail: (account.email ?? '').trim(),
                role: {
                    scope: scope,
                    targets: roleTargets,
                    subtargets: roleSubtargets,
                },
                storeCodes: isAdmin ? ["ALL_POI"] : storeCodes,
                isDefaultPassword: false,
                groups: groupCodes,
                isSso: isSso
            };
        });
    }

    handleCloseSnackbar = () => {
        this.setState({snackbarOpen: false});
    };

    async importUsersFromExcel(): Promise<void> {
        this.setState({modalContent: null});
        await userAdminService.createUsersFromExcel(this.props.client, this.state.usersToImport);
        this.setState({usersToImport: []});
        this.props.updateData();
    }

    public render(): JSX.Element {
        return (
            <div className="rows">
                <div className="searchZone">
                    <div>
                        <input value={this.state.inputFilter} className="filterSearch"
                               onChange={this.handleSearchFilter} placeholder="Rechercher" type="text"/>
                    </div>
                    <div className="sortPicker">
                        <select onChange={this.handlePasswordFilter}>
                            <option hidden value="">Filtrer (mot de passe)</option>
                            <option id="all" value="all">Voir tout (par défaut)</option>
                            <option id="defined" value="defined">Mot de passe défini</option>
                            <option id="undefined" value="undefined">Mot de passe non défini</option>
                        </select>
                    </div>
                    <div id={this.state.modalEnabledAction} className="searchButton">
                        <DropdownMenu actionClick={this.handleDropdowns}
                                      buttonText='Importer des utilisateurs'
                                      enabledActionName={this.state.modalEnabledAction}
                                      actionMenuList={importUsersOptionList}
                                      disabled={!this.props.client}
                                      ids={this.state.selectedUsers.map((user) => {
                                          return user.id
                                      })}
                                      ref={this.dropdownRef}></DropdownMenu>
                    </div>
                    <div className="searchButton createButton">
                        <button
                            className={this.props.client? "customButton w120 valid-btn" : "customButton w120 disabled"}
                            onClick={() => history.push('/user-creation/' + this.props.client, {clientId: this.props.client})}
                            disabled={!this.props.client}>Créer Utilisateur
                        </button>
                        <br/>
                    </div>
                    <div className="exportButton">
                        <button
                         onClick={() =>{this.exportUsers()}}
                            className={this.props.client && !this.state.isExporting  ? "customButton w120 valid-btn" : "customButton w120 disabled"}
                            disabled={ !this.props.client}
                        >
                            exporter les utilisateurs
                        </button>
                    </div> 
                    <div id={this.state.modalEnabledAction} className="searchButton actionButton">
                        <DropdownMenu
                            actionClick={this.handleDropdowns}
                            buttonText="Action"
                            enabledActionName={this.state.modalEnabledAction}
                            actionMenuList={this.props.isUsersActive ? actionActiveMenuList : actionInactiveMenuList}
                            disabled={this.state.disableActions}
                            ids={this.state.selectedUsers.map((user) => {
                                return user.id
                            })}
                            ref={this.dropdownRef}>
                        </DropdownMenu>
                    </div>
                    {this.state.showModal
                        ? <Modal onClose={this.handleDropdowns}
                            onValid={this.state.modalAction}
                            isShown={this.state.showModal}
                            headerText={this.state.modalTitle}
                            canValidate={!this.state.disableActionValidation}
                            modalContent={this.state.modalContent}>
                        </Modal> : ''
                    }
                </div>
                <div className="tableContent">
                    <table>
                        <thead className="tableHead">
                        <tr className="tableRow">
                            <th scope="col" onChange={() => this.selectAll(this.state.selectAll)}
                                className="tableCell checkboxCell headerCell">
                                <Checkbox disable={false}/>
                            </th>
                            <th scope="col" className="tableCell checkboxCell headerCell hidden">
                                <img src={temp_password_icon} className="logo"></img>
                            </th>
                            <th scope="col" className="tableCell headerCell dataCell">Prénom</th>
                            <th scope="col" className="tableCell headerCell dataCell">Nom</th>
                            <th scope="col" className="tableCell headerCell dataCell">Mail</th>
                            <th scope="col" className="tableCell headerCell dataCell">Dernière Modif.</th>
                            <th scope="col" className="tableCell checkboxCell headerCell hidden">
                                <img src={modify_icon} className="logo"></img>
                            </th>
                            <th scope="col" className="tableCell checkboxCell headerCell hidden">
                                <img src={delete_cross} className="logo"></img>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="tableBody" key={this.props.key}>
                        {this.state.currentList && this.state.currentList.map((row: any) => (
                            <tr key={row.user.id} className="tableRow">
                                <td scope="col" id={row.user.id} className="tableCell checkboxCell"
                                    onChange={() => this.select(row.user.id)}>
                                    <Checkbox disable={false} checkedValue={row.select}/>
                                </td>
                                <td scope="col" id={row.user.id} className="tableCell checkboxCell">
                                    <img src={row.user.isDefaultPassword ? temp_password_icon : valid_password_icon}
                                         className="logo"></img>
                                </td>
                                <td scope="col" id={row.user.id}
                                    className="tableCell dataCell">{row.user.firstName}</td>
                                <td scope="col" id={row.user.id} className="tableCell dataCell">{row.user.lastName}</td>
                                <td scope="col" id={row.user.id} className="tableCell dataCell">{row.user.mail}</td>
                                <td scope="col" id={row.user.id}
                                    className="tableCell dataCell">{row.user.lastUpdate.toLocaleDateString()}</td>
                                <td scope="col" id={row.user.id} className="tableCell checkboxCell">
                                    <button className="iconBtn">
                                        <img src={modify_icon} className="logo"
                                             onClick={() => history.push('/user-creation/' + this.props.client, {
                                                 clientId: this.props.client,
                                                 userId: row.user.id
                                             })}/>
                                    </button>
                                </td>
                                <td scope="col" id={row.user.id} className="tableCell checkboxCell">
                                    <button className="iconBtn">
                                        <img src={delete_cross} className="logo"
                                             onClick={() => {
                                                 row.select = true;
                                                 this.handleDropdowns("Supprimer un utilisateur")
                                             }
                                             }/>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <NotificationSnackbar
                    open={this.state.snackbarOpen}
                    message={this.state.snackbarMessage}
                    onClose={this.handleCloseSnackbar}
                    severity={this.state.snackbarSeverity}
                    autoHideDuration={this.state.snackbarAutoHideDuration}
                />
            </div>
        );
    }
}


export default UserAdminListFragment;